import { Box, Card, Stack } from "@mui/material";
import type { HunterSearchDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import type { Control, FieldPath, FieldValues } from "react-hook-form";
import { FormInputWithSlider } from "Components/Shared/Inputs/Form/FormInputWithSlider";
import { HunterCardHeader } from "Components/Shared/Inputs/HunterList/HunterCardHeader";

const COMPONENT_RESOURCES = Resources.Hunter.Merchants.NewRegistration;

type Props<FormType extends FieldValues> = {
  hunter: HunterSearchDto;
  control: Control<FormType>;
  onRemoveHunter?: (licensePublicID: string) => void;
  onCommissionUpdate: () => void;
  hasError: boolean;
};

export const HunterCard = <T extends object>({
  hunter: { companyName, firstName, lastName, licenseNo, licensePublicID },
  control,
  onRemoveHunter,
  onCommissionUpdate,
  hasError,
}: Props<T>) => {
  const { t } = useResource();

  return (
    <Card
      key={licensePublicID}
      elevation={0}
      sx={{
        border: hasError ? "1px solid red" : "1px solid #e0e0e0",
        borderRadius: 2,
      }}
    >
      <Box p={3}>
        <Stack width="100%" gap={2}>
          <HunterCardHeader
            companyName={companyName ?? undefined}
            licenseNo={licenseNo}
            onRemoveRequested={
              onRemoveHunter && licensePublicID
                ? () => onRemoveHunter(licensePublicID)
                : undefined
            }
          />
          <Box>
            <FormInputWithSlider
              control={control}
              label={t(COMPONENT_RESOURCES.Form.Fields.CommissionSettings)}
              name={`partyLicenseFees.${licensePublicID}` as FieldPath<T>}
              error={hasError}
              min={0}
              max={100}
              step={1}
              inputWidth={48}
              inputEndAdornment="%"
              onAfterChange={onCommissionUpdate}
            />
          </Box>
        </Stack>
      </Box>
    </Card>
  );
};
